import type { PaginatedQuery } from "@shared/types/list";
import { DEFAULT_PAGE_SIZE } from "@shared/types/list";
import { resolveCombinedSearchForRequest, resolveMultiSelectForRequest } from "@shared/utils/filterQuery";

export interface BrandQueryParam extends PaginatedQuery {
    admissionStatus: (number | string)[];
    authStatus: (number | string)[];
    /** 品牌名称搜索（模糊 string / 精确 string[]） */
    name: string | string[];
}

export interface BrandListRequestParams {
    page?: string;
    perPage?: string;
    name?: string | string[];
    admissionStatus?: (number | string)[];
    authStatus?: (number | string)[];
}

export const DEFAULT_BRAND_QUERY: BrandQueryParam = {
    admissionStatus: [],
    authStatus: [],
    name: "",
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
};

export function toBrandListRequestParams(query: BrandQueryParam): BrandListRequestParams {
    const params: BrandListRequestParams = {
        page: String(query.page),
        perPage: String(query.limit),
    };

    const admissionStatus = resolveMultiSelectForRequest(query.admissionStatus);
    if (admissionStatus) params.admissionStatus = admissionStatus;

    const authStatus = resolveMultiSelectForRequest(query.authStatus);
    if (authStatus) params.authStatus = authStatus;

    const name = resolveCombinedSearchForRequest(query.name);
    if (name) params.name = name;

    return params;
}

export function toBrandExportRequestParams(query: BrandQueryParam): Omit<BrandListRequestParams, "page" | "perPage"> {
    const params = toBrandListRequestParams(query);
    delete params.page;
    delete params.perPage;
    return params;
}
